import { GapRentalForm } from "@/app/GapRentals/Forms/GapRentalForm";
import { toGapRentalInput } from "@/app/GapRentals/Utils/gapRentalDistance";
import { getGapRentalUpdateInput } from "@/app/GapRentals/Utils/getGapRentalUpdateInput";
import { GapRentalFormValues } from "@/app/GapRentals/Utils/getDefaultGapRentalValues";
import { gapRentalDetailsValidation } from "@/app/GapRentals/Validation/gapRentalValidation";
import { RecordScreenFormCard } from "@/lib/Components/Screens/RecordScreen/Cards/RecordScreenFormCard";
import { RelocationInclusionType } from "@/gql/graphql";
import { RelocationInclusionsCard } from "@/app/Relocations/Forms/RelocationInclusionsCard";
import { RelocationStats } from "@/app/Relocations/Components/RelocationStats";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { updateRelocationMutation } from "@/app/Relocations/GraphQL/relocationMutations";
import { useRelocationRecord } from "@/app/Relocations/Hooks/useRelocationRecord";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { RelocationWorkOrdersCard } from "@/app/Relocations/Components/RelocationWorkOrdersCard";
import { RelocationAcknowledgementsCard } from "@/app/Relocations/Forms/RelocationAcknowledgementsForm";
import { GapRentalConfigurationFormCard } from "@/app/GapRentals/Forms/GapRentalConfigurationFormCard";
import { FeesFormCard } from "@/app/Relocations/Forms/FeesFormCard";
import { RelocationPurchasableExtrasCard } from "@/app/Relocations/Components/RelocationPurchasableExtrasCard";

/**
 * A gap rental's hire and distance settings follow the vehicle sitting idle at
 * the office rather than a route, so this screen never offers to write them
 * back to the trip defaults the way the relocation screen does.
 */
export function GapRentalDetailsScreen() {
  const { mutateAsync } = useGqlMutation(updateRelocationMutation);
  const record = useRelocationRecord();

  return (
    <div className="space-y-12 py-6">
      <RelocationStats />
      {record.workOrders.length > 0 ? <RelocationWorkOrdersCard /> : null}
      <RecordScreenFormCard<GapRentalFormValues>
        onSubmit={async (values) => {
          await mutateAsync({
            id: record.id,
            input: toGapRentalInput(values),
          });
        }}
        validationSchema={toFormikValidationSchema(gapRentalDetailsValidation)}
        enableReinitialize={true}
        title="Details"
        initialValues={getGapRentalUpdateInput(record)}
      >
        <GapRentalForm />
      </RecordScreenFormCard>
      <RelocationInclusionsCard
        relocation={record}
        excludedTypes={[
          RelocationInclusionType.Ferry,
          RelocationInclusionType.Fuel,
        ]}
      />
      <GapRentalConfigurationFormCard />
      <FeesFormCard />
      <RelocationPurchasableExtrasCard />
      <RelocationAcknowledgementsCard relocation={record} />
    </div>
  );
}
